import React, { ReactNode } from 'react';
import cx from 'classnames';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';

interface InvoiceListRowProps {
  icon?: ReactNode;
  className?: string;
  titleLabel: ReactNode;
  dateLabel: ReactNode;
  totalLabel: ReactNode;
  downloadId?: string | number;
}

export function InvoiceListRow({
  icon,
  className,
  titleLabel,
  dateLabel,
  totalLabel,
  downloadId,
}: InvoiceListRowProps) {
  return (
    <div
      className={cx(className, [
        'w-full flex flex-col xmd:flex-row gap-y-2 p-4 items-start xmd:items-center',
      ])}
    >
      <div className='w-full xmd:w-2/5 flex flex-row gap-x-4 items-center py-2'>
        {icon}
        <span className='v2-text-neutral-900 font-bold text-base'>
          {titleLabel}
        </span>
      </div>
      <div className='w-full xmd:w-1/5 text-base v2-text-neutral-500'>
        {dateLabel}
      </div>
      <div className='w-full xmd:w-1/5 text-base v2-text-neutral-500'>
        {totalLabel}
      </div>
      {downloadId && (
        <div className='w-full xmd:w-1/5 flex justify-end'>
          <a
            className='w-full xmd:w-auto'
            href={`/billing/invoices/${downloadId}/download`}
          >
            <Button
              variant={ButtonVariant.Secondary}
              className='w-full v2-text-neutral-900 py-2'
            >
              Download
            </Button>
          </a>
        </div>
      )}
    </div>
  );
}
